// extracted by mini-css-extract-plugin
export default {"AboutPage":"About_AboutPage__+OEB-","about":"About_about__BLELx"};